<template>
  <PlainStoryEditor
    v-model="value"
    :height="getOptionValue(LayoutHeight)"
    :max-height="getOptionValue(MaxHeight)"
    :max-width="getOptionValue(MaxWidth)"
    :min-height="getOptionValue(MinHeight)"
    :min-width="getOptionValue(MinWidth)"
    :preview="!isEditable"
    :border-radius="getOptionValue(BorderRadius)"
    :publication-id="useFanPublicationStore().publicationId"
    :use-border="isEditable"
    padding-left="none"
    padding-right="none"
    :width="getOptionValue(LayoutWidth)"
  />
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-components/render-engine/mixins/production/dynamic-element-with-context-mixin";
import PlainStoryEditor from "%/components/PlainStoryEditor.vue";
import useFanPublicationStore from "%/stores/fan-publication-store";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";
import MinHeight from "%/dynamic-components/render-engine/options/spacing-options/min-height";
import MinWidth from "%/dynamic-components/render-engine/options/spacing-options/min-width";
import MaxHeight from "%/dynamic-components/render-engine/options/spacing-options/max-height";
import MaxWidth from "%/dynamic-components/render-engine/options/spacing-options/max-width";
import LayoutWidthHeightOptions from "%/dynamic-components/render-engine/bundles/layout-width-height-options";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import BorderRadius from "%/dynamic-components/render-engine/options/border-options/border-radius";

export default {
  name: "DynamicAppStoryInputElement",
  components: { PlainStoryEditor },
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "pencil",
    elementType: "element",
  },
  hidden: true,
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.min-height": 100,
    }),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
  ],
  computed: {
    BorderRadius() {
      return BorderRadius;
    },
    MaxWidth() {
      return MaxWidth;
    },
    MaxHeight() {
      return MaxHeight;
    },
    MinWidth() {
      return MinWidth;
    },
    MinHeight() {
      return MinHeight;
    },
    LayoutHeight() {
      return LayoutHeight;
    },
    LayoutWidth() {
      return LayoutWidth;
    },
    isEditable() {
      return true;
    },
    value: {
      get() {
        try {
          return JSON.parse(this.valueFromContext);
        } catch (e) {
          return this.valueFromContext;
        }
      },
      set(value) {
        if (!this.editMode) {
          this.valueFromContext = JSON.stringify(value);
        }
      },
    },
  },
  methods: {
    useFanPublicationStore,
  },
};
</script>
